import {
    Directive, ElementRef, Input, HostListener, AfterViewInit
} from '@angular/core';

@Directive({
    selector: '[resizeMainWindow]'
})

export class ResizeDirective implements AfterViewInit {

    @Input('resizeMainWindow') sidebar;

    constructor(private el: ElementRef) {
    }

    @HostListener('window:resize') screenWidth() {
        let sidebarWidth = this.sidebar.offsetWidth;
        if(window.innerWidth >= 1200 && this.sidebar.offsetWidth === undefined) {
            sidebarWidth = 260;
        }
        let screenWidth = window.innerWidth;
        if (sidebarWidth > 0) {
            let calcWidth = screenWidth - sidebarWidth;
            if (calcWidth < 1200) {
                this.resizeSection(calcWidth);
            }
        } else {
            this.el.nativeElement.style.maxWidth = "1200px";
        }
    }

    ngAfterViewInit() {
        let sidebarWidth = this.sidebar.offsetWidth;
        let screenWidth = window.innerWidth;
        if(window.innerWidth >= 1200 && this.sidebar.offsetWidth === undefined) {
            sidebarWidth = 260;
        }
        let calcWidth = screenWidth - sidebarWidth;
        if (sidebarWidth >= 200) {
            if (calcWidth < 1200) {
                this.resizeSection(calcWidth);
            }
        } else {
            this.el.nativeElement.style.maxWidth = "1200px";
        }
    }

    private resizeSection(size) {
        this.el.nativeElement.style.maxWidth = size + "px";
    }
}
